import { ReactComponent as MyAccountIconSVG } from '@/assets/icons/MyAccountIcon.svg';
import { SVGProps } from 'react';

const MyAccountIcon = (props: SVGProps<SVGSVGElement>) => <MyAccountIconSVG {...props} />;

export default MyAccountIcon;
